import { Box } from "@mui/material"
import { useRootDivContext } from "../context/RootDivContext"

const Blur = () => {

  const { rootDivRef, isOpened } = useRootDivContext()

  return (
    <Box
      className={`react-blur ${isOpened ? '' : 'hidden'}`}
      onClick={() => {
        rootDivRef.current?.setAttribute('data-open', '0')
      }}
    ></Box>
  )
}

export default Blur